import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Image = styled('img')`
  display: block;
  height: auto;
  margin: 16px auto;
  max-width: 100%;

  ${props => props.theme.breakpoints.up('sm')} {
    margin: 0;
    padding: 24px;
  }
`

export const List = styled('ol')`
  margin: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    padding: 1rem 3rem;
  }
`

export const Item = styled('li')`
  color: ${props => props.theme.palette.brand.black1};
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 16px;

  ${props => props.theme.breakpoints.up('sm')} {
    text-align: left;
  }
`
